import { useState, useEffect } from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import { useEnv } from '../../../../context/env-context';
import { makeRequest } from '../../../../utils/makeRequest';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Spinner } from '../../../../components/Spinner';

function DashboardSettings() {
  const { apiOriginOrchestrator } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(true);
  const [status, setStatus] = useState(null);

  const getStatus = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = { token, url: `${apiOriginOrchestrator}/get_status`, method: 'GET' };

    try {
      const data = await makeRequest(config);

      setStatus(data);
    } catch (error) {
      setStatus('Error');
    } finally {
      setSpinner(false);
    }
  };

  const setSystemStatus = async systemStatus => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginOrchestrator}/set_status`,
      method: 'POST',
      data: JSON.stringify({ status: systemStatus }),
    };

    try {
      const data = await makeRequest(config);

      setStatus(data);
    } catch (error) {
      setStatus('Error');
    }
  };

  useEffect(() => {
    getStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = () => getStatus();

  const renderStatus = () => {
    if (status === 'up') {
      return 'Turned Off';
    }

    if (status === 'down') {
      return 'Turned On';
    }

    return '...';
  };

  return (
    <Card className="mt-3">
      <Card.Header className="d-flex justify-content-between">
        Settings
        <Button className="bo-button-inline-link" onClick={refresh}>
          Refresh
        </Button>
      </Card.Header>
      <Card.Body>
        <Spinner visible={spinner} size={36}>
          <Container>
            <Row className="align-items-center">
              <Col>
                <span>
                  Maintenance Notice: &nbsp;
                  <strong>{renderStatus()}</strong>
                </span>
                {status === 'up' && (
                  <Button className="bo-button-inline-link" onClick={() => setSystemStatus(1)}>
                    Turn On
                  </Button>
                )}
                {status === 'down' && (
                  <Button className="bo-button-inline-link" onClick={() => setSystemStatus(0)}>
                    Turn Off
                  </Button>
                )}
              </Col>
            </Row>
          </Container>
        </Spinner>
      </Card.Body>
    </Card>
  );
}

export default DashboardSettings;
